import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import setTokenToUser from '@/services/users/token'
import { storage } from '@/helper/storage';

export async function initPush() {
    const storedUser = await storage.getItem('user');
    const permStatus = await FirebaseMessaging.requestPermissions();
    console.log('🔐 Permisos FCM:', permStatus);

    if (permStatus.receive !== 'granted') {
        console.warn('⚠️ Permisos de notificaciones no concedidos');
        return;
    }

    const { token } = await FirebaseMessaging.getToken();
    if (!token) {
        console.warn('⚠️ No se pudo obtener token FCM');
        return;
    }

    console.log('✅ TOKEN FCM:', token);
    console.log('✅ STORED USER:', storedUser);

    if (storedUser) {
        const { id: userId } = JSON.parse(storedUser);
        console.log('✅ USER ID:', userId);
        await storage.setItem('fcm_token', token);
        await setTokenToUser(userId, token);
    }

    FirebaseMessaging.addListener('notificationReceived', (notification) => {
        console.log('📩 Notificación recibida:', notification);
    });

    FirebaseMessaging.addListener('notificationActionPerformed', (action) => {
        console.log('👉 Acción en notificación:', action);
    });
}
